import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 13 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2.5 0C1.39543 0 0.5 0.895431 0.5 2V10C0.5 11.1046 1.39543 12 2.5 12H10.5C11.6046 12 12.5 11.1046 12.5 10V2C12.5 0.895431 11.6046 0 10.5 0H2.5ZM7.1 2.4C7.1 2.06863 6.83137 1.8 6.5 1.8C6.16863 1.8 5.9 2.06863 5.9 2.4V5.4H2.9C2.56863 5.4 2.3 5.66863 2.3 6C2.3 6.33137 2.56863 6.6 2.9 6.6H5.9V9.6C5.9 9.93137 6.16863 10.2 6.5 10.2C6.83137 10.2 7.1 9.93137 7.1 9.6V6.6H10.1C10.4314 6.6 10.7 6.33137 10.7 6C10.7 5.66863 10.4314 5.4 10.1 5.4H7.1V2.4Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}